<template>
  <div style="height: 100%;">
    <van-nav-bar title="用户许可协议" left-text="" left-arrow @click-left="onClickLeft" />
    <privacyVue class="privacyStyle" />
  </div>
</template>
<script>
import privacyVue from "./compontent/privacy.vue";
import * as uni from "./../component/uni.webview.1.5.2.js";
import Vue from "vue";
document.addEventListener("UniAppJSBridgeReady", function() {
  Vue.prototype.myUni = uni;
});
export default {
  components: { privacyVue },
  methods: {
    onClickLeft() {
      uni.navigateBack({ delta: 1 });
      this.$router.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.privacyStyle{
  height: calc(100% - 46px);
  padding: 10px;
  overflow-y: auto;
}
</style>
